import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationService } from "app/services/application.service";
import { CarrierService } from "app/services/carrier.service";
import { DocumentsServiceService } from "app/services/documents-service.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { environment } from "environments/environment";
import { AnnualComplianceService } from "../service/annual-compliance.service";
import { PermitService } from "app/services/permit.service";
import { CorspdcService } from "app/services/corspdc.service";
import { Observable, forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import { AuthWebService } from "app/services/authweb.service";
import { FormBuilder } from "@angular/forms";
import { CountryService } from "app/services/country.service";
import {StepperContainerComponent} from '../../shared/stepper/stepper-container/stepper-container.component';
import { SharedModule } from 'app/shared.module';

@Component({
  selector: 'app-complianceconfirmation',
  templateUrl: './complianceconfirmation.component.html',
  styleUrls: ['./complianceconfirmation.component.scss']
})
export class ComplianceconfirmationComponent implements OnInit {

  selectedPermits = [];
  count: number;
  ids: string;
  pageNumber: number = 1;
  currentId: number;
  complianceIds: any=[];
  currentPermitDetails: any = [];
  uploadedDocs: any;
  permitDocumentsLink: any = [];
  @ViewChild("content") modal: NgbModal;
  isLoading: boolean = false;
  allDocs: any;
  message = "Loading Documents...";
  removeRef: any;
  pdfSrc: any;
  img: any;
  carrierId: any;
  accountBalance: any;
  complianceDetails: any;
  documentPayload = [];
  carrierDetails: any = [];
  compliantStatuses: any;
  user: any = {};
  countryName: any;
  countries:any = [];
  total:number=0;
    // Step 2 Variables
    complianceVehicleDetails: any = [];
    SelectedcomplianceVehicleDetails: any = [];
    permitPaymentDetails: any = [];
    feeToBePaid: number;
  
    //Varibles to Manage Stepper
    background1 = "var(--sapphire)";
    background2 = "var(--background)";
    background3 = "var(--background)";
  
    isProgress1 = true;
    isProgress2 = false;
    isProgress3 = false;
  
    isStepper1 = true;
    isStepper2 = false;
    isStepper3 = false;
  
    // PAYMENT FORM
    checkoutForm = this.formBuilder.group({
      PAY_REQUEST_ID: "",
      CHECKSUM: "",
    });
    payGateUrl: string = "https://secure.paygate.co.za/payweb3/process.trans";
    payReqId: string = "";
    checkSum: string = "";
    compList!:Observable<any>;
    annualDuplicate!:Observable<any>;
   
    @ViewChild(StepperContainerComponent) StepperContainer;
  applicationId: any;
  @Output() nextStepEmitter = new EventEmitter<number>();
  @Output() prevStepEmitter = new EventEmitter<number>();

    constructor(
      private formBuilder: FormBuilder,
      private authWebService: AuthWebService,
      private _router: Router,
      private _activatedRoute: ActivatedRoute,
      private _confirmDialogService: ConfirmDialogService,
      private _toastService: ToastNotificationService,
      private _applicationService: ApplicationService,
      private _document: DocumentsServiceService,
      private _carrier: CarrierService,
      private confirmDialogService: ConfirmDialogService,
      private documentService: DocumentsServiceService,
      private toastService: ToastNotificationService,
      private _annualCompliance: AnnualComplianceService,
      private _location: Location,
      private _permit: PermitService,
      private _correspondance: CorspdcService,
      private _country:CountryService
    ) {
      this.user = this.authWebService.userData
        ? this.authWebService.userData.User
        : null;
    }

  ngOnInit(): void {
    this.ids = this.getIdFromUrl(window.location.href);
    this.compList=this._annualCompliance.annualList;
    this.annualDuplicate=this._annualCompliance.annualDuplicateList;
    // this.ids = this._activatedRoute.snapshot.paramMap.get("ids");
     this.getIDs();
     this.getPermitDetailsByIdPayment();

  }

  getPermitDetailsById() {
    this.isLoading = true;
    this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
      (res: any) => {
        if (res) {

          this.currentPermitDetails = res;
          this.carrierId = res.carrier_id;
          this.applicationId = res.application_id;
          this.getCountries();
        }
        this.isLoading = false;
        this.getComplianceDetailsByVIN();
        this.getPermitRelatedDocsByID();
      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }

  getComplianceDetailsByVIN() {
    this.isLoading = true;
    console.log("vehicledetails",this.currentPermitDetails)
    const obj = {
    
      vin: this.currentPermitDetails.VN_num,
      
      company_regnumber: this.currentPermitDetails.company_registration,
    };
    this._annualCompliance.getComplianceStatuses(obj).subscribe(
      (res: any) => {
        if (res) {
          this.compliantStatuses = res;
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }

  /**
   * Method to get the Linked documents which can be uploaded for the permit
   */
  getPermitRelatedDocsByID() {
    // this.isLoading = true;
    // this._permitDocs
    //   .getLinkedAndUnlinkedDoctypes(this.currentPermitDetails.permit_type_id)
    //   .subscribe(
    //     (res: any) => {
    //       if (res && res.PermitLinked) {
    //         this.permitDocumentsLink = res.PermitLinked;
    //         this.getPermitDocumentsById();
    //       }
    //       this.isLoading = false;
    //     },
    //     (err) => {
    //       console.error(err);
    //       this.isLoading = false;
    //     }
    //   );
  }

  async getCountries() {
    try {
      this.isLoading = true;
      const result = await this._country.listAllCountries().toPromise();
      if (result) {
        this.countries = result;
        this.isLoading = false;
        this.countries.forEach((country) => {
          if (country.id == this.currentPermitDetails.country) {
            this.countryName = country.desc;
            console.log(this.countryName);
            return;
          }
        });
      }
    } catch (error) {
      this.isLoading = false;
    }
  }

  getPermitDocumentsById() {
    this.isLoading = true;
    this._document
      .getPermitById(this.currentPermitDetails.permits[0].application_id)
      .subscribe((res: any) => {
        if (res) {
          this.uploadedDocs = res;
          this.patchDocs();
        }
      });
  }

  //Go back to the listing page
  cancel() {
    this.carrierId
      ? this._router.navigate([`/annual-compliance/list/${this.carrierId}`])
      : history.back();
  }

  patchDocs() {
    let newArr = [];
    this.permitDocumentsLink.forEach((element) => {
      const document_type_id = element.document_type_id;
      const foundEl: Array<any> = this.uploadedDocs.filter(
        (item) => item.document_type_id == document_type_id
      );
      if (foundEl && foundEl.length) {
        foundEl.forEach((el) => {
          newArr.push({
            document_type_id: document_type_id,
            fileName: el.file_name,
            id: el.id,
            document_link: el.document_link,
            date_created: el.date_created,
          });
        });
      }
    });
    this.allDocs = newArr.reduce((groups, item) => {
      const group = groups[item.document_type_id.toString()] || [];
      group.push(item);
      groups[item.document_type_id] = group;
      return groups;
    }, {});
  }

  onClickSubmit(val) {
    switch (val) {
      case 2:
        if (this.documentPayload.length < 0) {
          return;
        } else {
          this.useDocument();
          break;
        }
      case 3:
        this.hideStepTwoFromBeingActive();
        this.stepThreeActiveTab();
        break;
    }
  }

  useDocument() {
    this.isLoading = true;
    this._document.useThisDocument(this.documentPayload).subscribe(
      (res: any) => {
        if (res) {
          this.isLoading = false;
          this.hideStepOneFromBeingActive();
          this.stepTwoActiveTab();
          this.getComplianceVehicleDetails();
          this.getCarrierDetails();
          this.getPaymentInfo();
        }
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

    //Get Compliance Certificate Payment Screen Details
    // getComplianceVehicleDetails() {
    //   this.isLoading = true;
    //   this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
    //     (response) => {
    //       this.isLoading = false;
    //       this.complianceVehicleDetails = response;
    //     },
    //     (err) => {
    //       console.error(err);
    //       this.isLoading = false;
    //     }
    //   );
    // }
  
    //Get Payment Info of Compliance
    getPaymentInfo() {
      this.isLoading = true;
      this._permit.getPaymentInfoForAnnualCompliance(this.currentId).subscribe(
        (res: any) => {
          this.permitPaymentDetails = res;
          if (res.permit_type && res.permit_type.charge_when_ind) {
            this.feeToBePaid =
              res.permit_type.charge_when_ind == 2
                ? res.permit_type.current_application_fee +
                  res.permit_type.current_fee
                : res.permit_type.current_application_fee;
          }
          this.isLoading = false;
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }

   // ------------Methods to Manage Stepper----------------------//
   jumpToDoc() {
    this.stepOneActiveTab();
    this.hideStepTwoFromBeingActive();
    this.hideStepThreeFromBeingActive();
  }

  stepOneActiveTab() {
    const stepOne = <HTMLElement>document.getElementsByClassName("step-one")[0];
    stepOne.style.fontSize = "20px";
    stepOne.style.fontWeight = "bold";
  }

  stepTwoActiveTab() {
    const stepTwo = <HTMLElement>document.getElementsByClassName("step-two")[0];
    stepTwo.style.fontSize = "20px";
    stepTwo.style.fontWeight = "bold";
    this.getAccountBalance(
      this.currentPermitDetails.carrier_account_id
    );
  }

  stepThreeActiveTab() {
    const stepTwo = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    stepTwo.style.fontSize = "20px";
    stepTwo.style.fontWeight = "bold";
  }

  hideStepOneFromBeingActive() {
    this.isStepper2 = true;
    this.isProgress1 = false;
    this.isStepper1 = false; //Hide Tab 1
    this.background2 = "var(--sapphire)";
    const element = <HTMLElement>document.getElementsByClassName("step-one")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  hideStepTwoFromBeingActive() {
    this.isStepper3 = true;
    this.isProgress2 = true;
    this.background3 = "var(--sapphire)";
    const element = <HTMLElement>document.getElementsByClassName("step-two")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  hideStepThreeFromBeingActive() {
    this.background1 = "var(--sapphire)";
    this.background2 = "var(--background)";
    this.background3 = "var(--background)";

    this.isProgress1 = true;
    this.isProgress2 = false;
    this.isProgress3 = false;

    this.isStepper1 = true;
    this.isStepper2 = false;
    this.isStepper3 = false;
    const element = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  // ------------Methods to Manage Stepper (END)-----------------//

    //Get Carrier Details
    getCarrierDetails() {
      this.isLoading = true;
      this._carrier.getCarrierById(this.carrierId).subscribe((res: any) => {
        this.carrierDetails = res;
      });
    }

    getAccountBalance(customerCode) {
      if (customerCode) {
        this._carrier.getUpdateBalance(customerCode).subscribe((res: any) => {
          this.accountBalance = -res.Result.AccountBalance;
        });
      }
    }


    goNext(){
      // this.StepperContainer.activeStepper.isProgress = 'false';
      // this.StepperContainer.next();
    }
    prevStep(){
      this.prevStepEmitter.emit(0)
    }

    getIDs() {
      if (this.ids) {
        this.complianceIds = this.ids.split("_");
        this.currentId = this.complianceIds[0];
        this.getPermitDetailsById();
       // this.getPermitDetailsById();
      }
    }

    getIdFromUrl(url: string): string | null {
      const regex = /\/(\w+)$/; // Matches a word at the end of the URL
      const matches = regex.exec(url);
      if (matches && matches.length >= 2) {
        return matches[1];
      }
      return null; // ID not found or invalid URL
    }

    getPermitDetailsByIdPayment() {
      this.isLoading = true;
      this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
        (res: any) => {
          if (res) {
            this.getAccountBalance(res.carrier_account_id);
            this.carrierId = res.carrier_id;
            if(res.Is_duplicate)
            {this.getComplianceDuplicateDetails()}
            else{
            this.getComplianceVehicleDetails();}
          }
          this.isLoading = false;
  
        },
        (err) => {
          this.isLoading = false;
          console.error(err);
        }
      );
    }


    getComplianceVehicleDetailsOld() {
      // this.isLoading = true;
      this.compList.subscribe(
        (response) => {
          this.isLoading = false;
          console.log("this the response", response);
          if(response){
          this.complianceVehicleDetails = response;
          this.SelectedcomplianceVehicleDetails.length = 0;

          this.complianceVehicleDetails.forEach(payment => {
            if(this.complianceIds.includes(payment.id.toString()))
               this.SelectedcomplianceVehicleDetails.push(payment);
          });
          this.complianceVehicleDetails = this.SelectedcomplianceVehicleDetails;
          this.complianceVehicleDetails.forEach(compliance =>  { this.total=this.total+compliance.line_total+compliance.duplicate_fee });
          }
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }

    getComplianceDuplicateDetailsOld() {
      // this.isLoading = true;
      this.annualDuplicate.subscribe(
        (response) => {
          this.isLoading = false;
          console.log("this the response", response);
          if(response){
          this.complianceVehicleDetails = response;
          this.SelectedcomplianceVehicleDetails.length = 0;

          this.complianceVehicleDetails.forEach(payment => {
            if(this.complianceIds.includes(payment.id.toString()))
               this.SelectedcomplianceVehicleDetails.push(payment);
          });
          this.complianceVehicleDetails = this.SelectedcomplianceVehicleDetails;
          this.complianceVehicleDetails.forEach(compliance =>  { this.total=this.total+compliance.line_total+compliance.duplicate_fee });
          }
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }

    getComplianceVehicleDetails() {
      this.isLoading = true;
      this._annualCompliance.getCompliancesSelected(this.ids).subscribe(
        (response) => {
          this.isLoading = false;
          this.complianceVehicleDetails = response;
          this.complianceVehicleDetails.forEach(compliance => 
             { 
              this.total=this.total+compliance.line_total + compliance.duplicate_fee
            });
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }
    getComplianceDuplicateDetails() {
      this.isLoading = true;
      this._annualCompliance.getCompliancesSelectedDuplicate(this.ids).subscribe(
        (response) => {
          this.isLoading = false;
          this.complianceVehicleDetails = response;
          this.complianceVehicleDetails.forEach(compliance =>  { 
            this.total=this.total+compliance.line_total + compliance.duplicate_fee
          });
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }


    nextStep(){
      this.nextStepEmitter.emit(0)
    }
    // getComplianceDuplicateDetailsOld() {
    //   this.isLoading = true;
    //   const list: number[]  = Array.from(this.complianceIds);
    //   this._annualCompliance.getComplianceConfirmationForDuplicate(list).subscribe(
    //     (response) => {
    //       this.isLoading = false;
    //       this.complianceVehicleDetails = response;
    //       this.SelectedcomplianceVehicleDetails.length = 0;

    //       this.complianceVehicleDetails.forEach(payment => {
    //         if(this.complianceIds.includes(payment.id.toString()))
    //            this.SelectedcomplianceVehicleDetails.push(payment);
    //       });
    //       this.complianceVehicleDetails = this.SelectedcomplianceVehicleDetails;
    //       this.complianceVehicleDetails.forEach(compliance =>  { 
    //         this.total=this.total+compliance.line_total + compliance.duplicate_fee
    //       });
    //     },
        
    //     (err) => {
    //       console.error(err);
    //       this.isLoading = false;
    //     }
    //   );
    // }

}
